// "1 code", "2 codes". Pass `plural` for words that don't just take an "s".
const pluralize = (count: number, singular: string, plural = `${singular}s`) =>
  `${count} ${count === 1 ? singular : plural}`;

export default pluralize;
